import React from 'react'
import ResellersContainer from 'containers/panel/admin/resellers-container'

const ResellersPage = () => {
  return (
    <ResellersContainer/>
  )
}

export default ResellersPage